module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/autocompletes-cbec0b6d3949e133857b0684ddd8317b.svg";